import { render, staticRenderFns } from "./TariffsBanner.vue?vue&type=template&id=60568cf9&scoped=true&"
import script from "./TariffsBanner.vue?vue&type=script&lang=js&"
export * from "./TariffsBanner.vue?vue&type=script&lang=js&"
import style0 from "./TariffsBanner.vue?vue&type=style&index=0&id=60568cf9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60568cf9",
  null
  
)

export default component.exports